import PropTypes from 'prop-types';

const SmileIcon = ({ color = '#0D0D0D', className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 23.25C5.78661 23.25 0.75 18.2134 0.75 12C0.75 5.78661 5.78661 0.75 12 0.75C18.2134 0.75 23.25 5.78661 23.25 12C23.25 18.2134 18.2134 23.25 12 23.25Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M7.20013 13.2C7.20013 14.4731 7.70585 15.694 8.60602 16.5941C9.5062 17.4943 10.7271 18 12.0001 18C13.2732 18 14.4941 17.4943 15.3942 16.5941C16.2944 15.694 16.8001 14.4731 16.8001 13.2H7.20013Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

SmileIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
};

export default SmileIcon;
